import {RSAA} from 'redux-api-middleware';

import {composeURL} from '../../../utils/url';
import {showServerError} from '../../../actions/notifications';

let sphericalVoronoiSeed;

const apiUrl = "https://qn3ibs0ril.execute-api.eu-west-2.amazonaws.com/backend";

export const PLANET_REQUEST = '@@scenePlanet/PLANET_REQUEST',
    PLANET_SUCCESS = '@@scenePlanet/PLANET_SUCCESS',
    PLANET_ERROR = '@@scenePlanet/PLANET_ERROR',
    UPDATE_ELEVATION = '@@scenePlanet/UPDATE_ELEVATION',
    UPDATE_RADIUS = '@@scenePlanet/UPDATE_RADIUS',
    computePlanet = (timestamp, params) => dispatch => {
        const seed = timestamp;
        sphericalVoronoiSeed = seed;
        dispatch({
            [RSAA]: {
                bailout: () => sphericalVoronoiSeed !== seed,
                endpoint: composeURL(`${apiUrl}/planet/${seed}`, params),
                // endpoint: composeURL(`planet/${seed}`, params),
                options: {
                    mode: 'cors',
                    timeout: 300
                },
                method: 'GET',
                types: [
                    {
                        type: PLANET_REQUEST,
                        payload: {
                            seed
                        }
                    },
                    PLANET_SUCCESS, {
                        type: PLANET_ERROR,
                        payload: (action, state, response) => {
                            console.log('computePlanet error');
                            dispatch(showServerError(response, 8000));
                            return response;
                        }
                    }
                ]
            }
        });
    },
    updateElevation = (elevation) => ({type: UPDATE_ELEVATION, elevation}),
    updateRadius = (radius) => ({type: UPDATE_RADIUS, radius});


// WEBPACK FOOTER //
// ./src/apps/scene-planet/actions/planet.js